<template>
  <div class="rc-layout-design" :class="{'rc-layout-design-select':getborder, 'rc-layout-highlight-select':getHighlight}">
    <div
      class="draggable-module"
      :class="component.componentType"
      v-for="(component,index) in initComponent.children"
      :style="getRatioStyle(index)"
      :key="component.id"
      @click.stop="openAttrForChildren"
      @dblclick="getHighlightStyle">
      <component
        ref="childrenComponent"
        :is="component.componentType"
        :initComponent="component"
        :selectId="selectId"
        :nodeIsCountersign="nodeIsCountersign"
        :parentComponent="parentComponent">
      </component>
    </div>
  </div>
</template>

<script>
import RcDraggable from '../draggable/rc-draggable.vue'

export default {
  name: 'rc-layout',
  inject: ['formService', 'componentEventBus'],
  props: [ 'initComponent', 'selectId', 'nodeIsCountersign', 'parentComponent', 'highlightId' ],
  components: {
    RcDraggable
  },
  data () {
    return {
      highLight: false,
      timer: null
    }
  },
  methods: {
    openAttrForChildren () {
      clearTimeout(this.timer)
      // 区分单击和双击
      this.timer = setTimeout(() => {
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentAttr', id: this.initComponent.id})
      }, 200)
    },
    getRatioStyle (index) {
      let flexStyle = '1 1'
      if (this.initComponent.properties.layoutRatioType) {
        let countRatio = 0
        let ratioArray = this.initComponent.properties.layoutRatioType.split(':')
        ratioArray.forEach(e => { countRatio += Number(e) })
        flexStyle = `1 1 ${ratioArray[index] / countRatio * 100}%`
      }
      let style = {'flex': flexStyle}
      return style
    },
    getHighlightStyle (component) {
      // 更改当前selectId
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.componentEventBus.$emit('highlightLayout', {state: 'layout', id: this.initComponent.id})
    }
  },
  computed: {
    getborder () {
      let removeIcon = this.initComponent.children.some(m => m.id === this.selectId)
      return removeIcon
    },
    getHighlight () {
      return this.highlightId === this.initComponent.id
    }
  }
}
</script>

<style lang="scss">
  .rc-layout-design {
    display: flex;
    align-items: stretch;
    position: relative;
    margin-top: 10px;
    padding: 10px 0;
    &.rc-layout-design-select {
      border: 1px solid #55ACF1;
      >div>.el-icon-circle-close {
        display: block;
      }
    }

    &.rc-layout-highlight-select{
      border: 1px dashed #2bcb7e ;
    }

    .title {
      position: absolute;
      top: -10px;
      left: 20px;
      padding: 0 10px;
      background: #fff;
    }

    .draggable-module {
      flex: 1;
      max-width: 100%;
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      overflow-x: hidden;
      &:first-child {
        padding-left: 0 !important;
      }
      &:last-child {
        padding-right: 0;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/layout/rc-layout.vue